import { Inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

/** Sunday-indexed — Material rotates this array by `getFirstDayOfWeek()`. */
const NARROW_DAYS_OF_WEEK = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

/**
 * Moment adapter pinned to a Monday-first week and fixed day labels, so every
 * calendar in the app reads Mo–Su whatever the browser locale is.
 */
@Injectable()
export class MondayFirstDateAdapter extends MomentDateAdapter {
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
    super(dateLocale);
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    return style === 'narrow'
      ? [...NARROW_DAYS_OF_WEEK]
      : super.getDayOfWeekNames(style);
  }
}
